// PageSignupConfirm Component
/* eslint standard/no-callback-literal:0 */

import React, { Component } from 'react'
import async from 'async'
import PropTypes from 'prop-types'

import app from '../../../app.jsx'
import SignupConfirmContent from '../../signup/signup_confirmcontent/signup_confirmcontent.jsx'

class PageSignupConfirm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      dataDate: null,
      password: '',
      imageAvatar: null,
      imageAvatarUrl: null,
      imageDeleted: false
    }

    this.data = {
      userId: null,
      user: null,
      team: null
    }
  }

  static get propTypes () {
    return {
      token: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      token: ''
    }
  }

  componentDidMount () {
    this._getData()
  }

  render () {
    if (!this.data.team) {
      return null
    }

    return (
      <div className='page-signup'>
        <SignupConfirmContent
          email={this.data.team.profile.email}
          checkUserExists={this._checkUserExists.bind(this)}
          onSubmit={this._onSignupTeam.bind(this)}
        />
      </div>
    )
  }

  _checkUserExists (email, callback) {
    if (email) {
      const userParams = { query: { email: email } }
      app
        .service('/api/users')
        .find(userParams)
        .then(userRes => {
          if (userRes && userRes.data && userRes.data.length > 0) {
            callback(true)
          } else {
            callback(false)
          }
        })
        .catch(userErr => {
          app.debug('### PageSignupTeam: _checkUserExists ', userErr)
          callback(false)
        })
    } else {
      callback(false)
    }
  }

  _getData () {
    async.series(
      [
        done => {
          this._getConfirmTeam(done)
        }
      ],
      (asyncErr, _asyncRes) => {
        if (asyncErr) {
          this.setState({ dataDate: new Date() })
          this._showError(asyncErr)
        }
      }
    )
  }

  _getConfirmTeam (callback) {
    const params = { query: { 'demoInfo.confirmCode': this.props.token } }
    app
      .service('/api/team')
      .find(params)
      .then(teamRes => {
        this.data.team = teamRes.data[0]
        this.forceUpdate()
        callback(null)
      })
      .catch(userErr => {
        callback(userErr)
        app.debug('### PageSignupConfirm: _getConfirmTeam ', userErr)
      })
  }

  _showError (err) {
    app.error(err)
  }

  /* Private functions */
  _onSignupTeam (signupObj) {
    signupObj.timezone = this._getTimezone(signupObj.country)
    const params = { query: { code: this.props.token } }
    app
      .service('/api/signup/confirm')
      .patch(null, signupObj, params)
      .then(userRes => {
        this._onLogin(userRes.userTeam, signupObj.password, () => {
          app.setUser(this.data.user)
          app.teamContext.setActiveUserTeam(userRes)
          this._createUserHistory(userRes.userTeam)
        })
      })
      .catch(userErr => {
        app.debug('### PageSignupConfirm: _onSignupTeam ', userErr)
      })
  }

  _createUserHistory (userTeam) {
    const params = {
      query: {
        $client: { teamId: userTeam.teamId }
      }
    }

    const historyObj = { userId: userTeam.userId }
    app
      .service('/api/user/history')
      .create(historyObj, params)
      .then(result => {
        if (result) {
          app.set('appUserHistoryId', result.id)
        }
        app.redirect('/')
      })
      .catch(err => {
        app.debug('### PageSignupConfirm: _createUserHistory ', err)
        app.redirect('/')
      })
  }

  _onLogin (userTeam, password, callback) {
    app.feathersApp
      .authenticate({
        strategy: 'local',
        email: userTeam.email,
        password: password
      })
      .then(({ user }) => {
        this.data.user = user
        this.data.userId = user.id

        callback(null)
      })
      .catch(error => {
        callback(error)
        app.debug('### Page signup: onLogin ', error)
      })
  }

  _getTimezone (country) {
    if (country === 'DE') {
      return 'Europe/Berlin'
    } else if (country === 'UK') {
      return 'Europe/London'
    } else if (country === 'US') {
      return 'America/New_York'
    }

    return 'Europe/Amsterdam'
  }
}

export default PageSignupConfirm
